<h1 class="visually-hidden">{{ 'orders.newOrder' | transloco }}</h1>
<div class="padding">
    <div class="flex-container">
      <div class="flex-item">
        <div class="margin-sides-15">
          <mat-card>
            <mat-card-content>
              <mat-horizontal-stepper #orderStepper [linear]="false">
                <mat-step [label]="'orders.orderInfo' | transloco" completed="false" state="edit">
                  <form #form="ngForm">
                    <div class="padding">
                      <form [formGroup]="baseOrderDetails" class="padding">
                        @if (orderTypeGroupIDs[0] == ppsaRegistrationOrderTypeGroup) {
                          <div class="flex-container"
                            >
                            <mat-checkbox class="flex-item" [(ngModel)]="isHistorical"
                              [ngModelOptions]="{standalone: true}" [disabled]="shouldDisableHistoricalCheckbox()"
                              data-testid="historical-checkbox">
                              {{ 'orders.historical' | transloco }}
                            </mat-checkbox>
                          </div>
                        }
                        <app-static-warnings [showHistoricalWarning]="isHistorical"
                        [showBasicWarning]="isBasic"></app-static-warnings>
                        <div class="flex-container">
                          <mat-form-field class="flex-item form-field" appearance="outline">
                            <mat-label>{{ 'common.labels.referenceNumber' | transloco }}</mat-label>
                            <input matInput [formControlName]="'referenceNumber'"
                              [placeholder]="'common.labels.referenceNumber' | transloco"
                              data-testid="reference-number-field">
                            <mat-error>{{ 'orders.referenceNumberIsRequired' | transloco }}</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="flex-container">
                          <mat-form-field class="flex-item form-field" appearance="outline">
                            <mat-label>{{ 'common.labels.orderType' | transloco }}</mat-label>
                            <mat-select [formControlName]="'orderTypeID'"
                              (selectionChange)="onOrderTypeSelectionChange()" data-testid="order-type-dropdown">
                              @for (orderType of orderTypes; track orderType) {
                                <mat-option
                                  [value]="orderType.value"
                                  [attr.data-testid]="'order-type-option-' + orderType.label.replaceAll(' ', '-').toLowerCase()">
                                  {{orderType.label}}
                                </mat-option>
                              }
                            </mat-select>
                            <mat-error>{{ 'orders.orderTypeIsRequired' | transloco }}</mat-error>
                          </mat-form-field>
                          @if (selectedOrderType) {
                            <mat-form-field class="flex-item form-field"
                              appearance="outline">
                              <mat-label>{{ 'common.labels.country' | transloco }}</mat-label>
                              <mat-select [formControlName]="'country'"
                                data-testid="country-dropdown"
                                (selectionChange)="handleCountryChangeEvent()">
                                @for (country of countries; track country) {
                                  <mat-option
                                    [value]="country.countryCode"
                                    [attr.data-testid]="'country-option-' + country.countryFullName.toLowerCase()">
                                    {{country.countryFullName}}
                                  </mat-option>
                                }
                              </mat-select>
                              <mat-error>{{ 'orders.countryIsRequired' | transloco }}</mat-error>
                            </mat-form-field>
                          }
                          @if (selectedOrderType && shouldShowJurisdiction) {
                            <mat-form-field class="flex-item form-field"
                              appearance="outline">
                              <mat-label>{{ 'common.labels.jurisdiction' | transloco }}</mat-label>
                              <mat-select [formControlName]="'jurisdiction'"
                                data-testid="jurisdiction-dropdown"
                                (selectionChange)="handleJurisdictionChangeEvent()">
                                @for (jurisdiction of jurisdictions; track jurisdiction) {
                                  <mat-option
                                    [value]="jurisdiction.jurisdictionCode"
                                    [attr.data-testid]="'jurisdiction-option-' + jurisdiction.jurisdictionCode.toLowerCase()">
                                    {{jurisdiction.jurisdictionFullName}}
                                  </mat-option>
                                }
                              </mat-select>
                              <mat-error>{{ 'orders.jurisdictionIsRequired' | transloco }}</mat-error>
                            </mat-form-field>
                          }
                          @if (selectedOrderType && shouldShowJurisdictionMulti) {
                            <div form formGroupName="searchParameters" class="form-field flex-item">
                              <mat-form-field appearance="outline" class="flex-container">
                                <mat-label>{{ 'common.labels.jurisdictions' | transloco }}</mat-label>
                                <mat-select formControlName="searchJurisdictions" [placeholder]="'common.labels.jurisdictions' | transloco" multiple="true"
                                  data-testid="jurisdictions-dropdown" (selectionChange)="onJurisdictionsSelectionChange($event)">
                                  <mat-option>
                                    <ngx-mat-select-search [formControl]="jurisdictionFilterControl" placeholderLabel="Search..."
                                      noEntriesFoundLabel=" No matches found">
                                    </ngx-mat-select-search>
                                  </mat-option>
                                  @for (jurisdiction of filteredJurisdictions | async; track jurisdiction) {
                                    <mat-option [value]="jurisdiction.jurisdictionCode"
                                      [attr.data-testid]="'jurisdictions-option-' + jurisdiction.jurisdictionCode.toString().toLowerCase()">
                                      {{ jurisdiction.jurisdictionFullName }}
                                    </mat-option>
                                  }
                                </mat-select>
                                <mat-error>{{ 'orders.atLeastOneJurisdictionIsRequired' | transloco }}</mat-error>
                              </mat-form-field>
                            </div>
                          }
                        </div>
                        @if (shouldShowQCFormTypes()) {
                          <form formGroupName="lien">
                            <div class="flex-container">
                              <mat-form-field class="flex-item form-field" appearance="outline">
                                <mat-label>{{ 'common.labels.formType' | transloco }}</mat-label>
                                <mat-select formControlName="qcFormTypeID"
                                  data-testid="qcform-dropdown">
                                  @for (qcFormType of qcFormTypes; track qcFormType) {
                                    <mat-option
                                      [value]="qcFormType.value"
                                      [attr.data-testid]="'form-type-option-' + qcFormType.label.split(' ')[0].toLowerCase()">
                                      {{qcFormType.label}}
                                    </mat-option>
                                  }
                                </mat-select>
                                <mat-error>{{ 'orders.formTypeIsRequired' | transloco }}</mat-error>
                              </mat-form-field>
                            </div>
                          </form>
                        }
                        @if (_userGroups.length > 1) {
                          <div class="flex-container">
                            <mat-form-field appearance="outline" class="flex-item form-field">
                              <mat-label>{{ 'orders.requestFor' | transloco }}</mat-label>
                              <mat-select [formControlName]="'userGroupID'">
                                @for (userGroup of _userGroups; track userGroup) {
                                  <mat-option [value]="userGroup.value">
                                    {{userGroup.label}}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        }
                        @if (_bundles.length > 1) {
                          <div class="flex-container">
                            <mat-form-field appearance="outline" class="flex-item form-field">
                              <mat-label>{{ 'orders.addToBundle' | transloco }}</mat-label>
                              <mat-select [formControlName]="'bundleID'">
                                <mat-option [value]="null">{{ 'orders.none' | transloco }}</mat-option>
                                @for (bundle of _bundles; track bundle) {
                                  <mat-option [value]="bundle.value">
                                    {{bundle.label}}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        }
                      </form>
                    </div>
                  </form>
                  <!-- Navigation buttons -->
                  <div class="flex-container padding-top">
                    <span class="spacer"></span>
                    <span class="spacer"></span>
                    <span class="spacer"></span>
                    <span class="spacer"></span>
                    <span class="spacer"></span>
                    <button mat-raised-button (click)="saveContents()" color="primary"
                      class="apply-padding flex-item form-field" [attr.aria-label]="'orders.nextStepButton' | transloco"
                      data-testid="order-info-next-button">
                      {{ 'common.buttons.next' | transloco }}
                    </button>
                  </div>
                </mat-step>
                <ng-template matStepperIcon="edit">
                  <mat-icon>edit</mat-icon>
                </ng-template>
              </mat-horizontal-stepper>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
</div>